import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiResponse } from '../models/api-response.model';
import { map } from 'rxjs';

export interface TraspasoItem {
  item_id: string;
  cantidad: number;
  no_parte?: string;
  nombre?: string;
  precio_compra?: number;
}

export interface TraspasoRecepcionItem {
  item_id: string;
  cantidad_recibida: number;
  merma?: number;
}

export interface Traspaso {
  id?: string;
  tenant_id?: string;
  origen_id: string;
  destino_id: string;
  items: TraspasoItem[];
  items_recibidos?: TraspasoRecepcionItem[];
  estado: 'EN_TRANSITO' | 'COMPLETADO' | 'PARCIAL' | 'RECHAZADO';
  creado_por?: { id: string; nombre: string };
  recibido_por?: { id: string; nombre: string };
  createdAt?: string;
  updatedAt?: string;
}

@Injectable({
  providedIn: 'root'
})
export class TraspasosService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/inventario/traspasos`;

  create(data: Partial<Traspaso>): Observable<Traspaso> {
    return this.http.post<ApiResponse<Traspaso>>(this.apiUrl, data).pipe(map(res => res.data));
  }

  getAll(sucursal_id?: string, tipo: 'entrantes' | 'salientes' | 'todos' = 'todos', estado?: string): Observable<{items: Traspaso[]}> {
    let params: any = { tipo };
    if (sucursal_id) params.sucursal_id = sucursal_id;
    if (estado) params.estado = estado;
    return this.http.get<ApiResponse<{items: Traspaso[]}>>(this.apiUrl, { params }).pipe(map(res => res.data));
  }

  receive(id: string, payload: { estado: string; items_recibidos: TraspasoRecepcionItem[] }): Observable<any> {
    return this.http.put<ApiResponse<any>>(`${this.apiUrl}/${id}/recepcion`, payload).pipe(map(res => res.data));
  }
}
